import { State, get_state } from "./redux/State"
import { Rectangle } from "./Rectangle"
import { Point } from "./Point"
import { Actions } from "./redux/Actions"
import { Id_floor, Id_location, Id_attachment } from "./api/Identifiers"
import { cms_logging } from "./cms_logging";
import { Keys, StateValues } from "./redux/Datastore";
import { Dispatcher } from "./redux/Dispatcher";
import { Configuration } from "./Configuration";
import { QueryString } from "./QueryString";
import { exists } from "./utils";


export class AttachmentApiObject {
    private constructor(
        readonly id: Id_attachment,
        readonly url: string,
        readonly base_64: string,
        readonly file_extension: string,
        readonly coord: Point,
        readonly p1: Point,
        readonly p2: Point,
        readonly id_location: Id_location,
        readonly id_room: Id_location,
        // todo: add id_room
        readonly is_image: boolean,
        readonly is_create: boolean,
        readonly is_update: boolean,
        readonly is_delete: boolean,
    ) { }
    public static build_create_url_attachment(url: string, coord: Point, p1: Point, p2: Point, id_location: Id_location) {
        return new AttachmentApiObject(null, url, null, null, coord, p1, p2, id_location, null, false, true, false, false);
    }
    public static build_create_image_attachment(base_64: string, file_extension: string, coord: Point, p1: Point, p2: Point, id_location: Id_location) {
        return new AttachmentApiObject(null, null, base_64, file_extension, coord, p1, p2, id_location, null, true, true, false, false);
    }
    public static build_delete_attachment(id: Id_attachment) {
        return new AttachmentApiObject(id, null, null, null, null, null, null, null, null, false, false, false, true);
    }
    public static build_update_attachment(id: Id_attachment, coord: Point, p1: Point, p2: Point, id_location: Id_location) {
        return new AttachmentApiObject(id, null, null, null, coord, p1, p2, id_location, null, false, false, true, false);
    }
}


let api_token:string = QueryString.api_token;
let api_gateway:string = QueryString.api_gateway
let api_id_segment:number = QueryString.id_segment
let module_id:number = 1; // default for cms_tech

if (Configuration.is_cms_rounding){
    module_id = 37;  // magic number. This tells the API that the calling app is CMS rounding.
}


function build_get_simple_call(endpoint_url: string): any {
    return {
        type: "GET",
        url: endpoint_url,
        dataType: "json",
        headers: {
            Accept: "application/json, text/plain, */*",
        },
        complete: function (xhr: any, textStatus: any) {
            console.log("COMPLETE " + endpoint_url + "  " + textStatus)
        },
        success: function (data: any, textStatus: any, xhrxhr: any) {
            console.error("success function for " + endpoint_url + " was not overridden: " + textStatus)
        },
        error: function (xhr: any, textStatus: any, errorThrown: any) {
            console.error("ERROR " + endpoint_url + "  " + textStatus + "  " + errorThrown)
        }
    }
}


function build_get_txt_call(endpoint_url: string): any {
    return {
        type: "GET",
        url: endpoint_url,
        dataType: "text",
        headers: {
            Accept: "text/plain, */*",
        },
        complete: function (xhr: any, textStatus: any) {
            console.log("COMPLETE " + endpoint_url + "  " + textStatus)
        },
        success: function (data: any, textStatus: any, xhrxhr: any) {
            console.error("success function for " + endpoint_url + " was not overridden: " + textStatus)
        },
        error: function (xhr: any, textStatus: any, errorThrown: any) {
            console.error("ERROR " + endpoint_url + "  " + textStatus + "  " + errorThrown)
        }
    }
}


function build_get_api_call(endpoint_url: string): any {
    return {
        type: "GET",
        url: endpoint_url,
        dataType: "json",
        headers: {
            Authorization: "Bearer " + api_token,
            Accept: "application/json, text/plain, */*",
            CmsSegmentId: api_id_segment,
            "Cache-Control": "no-cache",
            ModuleId: module_id
        },
        complete: function (xhr: any, textStatus: any) {
            console.log("COMPLETE " + endpoint_url + "  " + textStatus)
        },
        success: function (data: any, textStatus: any, xhrxhr: any) {
            console.error("success function for " + endpoint_url + " was not overridden: " + textStatus)
        },
        error: function (xhr: any, textStatus: any, errorThrown: any) {
            console.error("ERROR " + endpoint_url + "  " + textStatus + "  " + errorThrown)
        }
    }
}

function build_post_api_call(endpoint_url: string,
    data_to_post: any): any {
    var r = build_get_api_call(endpoint_url);
    r.type = "POST";
    r.headers['Content-Type'] = 'application/json';
    r.data = JSON.stringify(data_to_post);
    return r;
}


/** Builds the headers for a DELETE REST call */
function build_delete_api_call(url: string): any {
    let r: any = build_get_api_call(url);
    r.type = "DELETE";
    r.dataType = "text";
    r.headers['Content-Type'] = '*/*';//'application/json';
    r.data = "";
    return r;

}


export class CmsApi {
    private static  findings_floors_downloaded: Id_location[] = [];
    private constructor() { }

    public static delete_deleteattachment(id_attachment: Id_attachment): void {
        if (!id_attachment) {
            console.error(`cannot delete ${id_attachment}`);
            return
        }

        var url = `${api_gateway}/api/drawinglocations/deleteattachment/${id_attachment.toString()}`

        let call: any = build_delete_api_call(url);//__buildDeleteApiCall(url, api_token, api_segment_id)
        call.complete = function (xhr: any, textStatus: any) {
            // pass
        }
        call.success = function (retval: any, textStatus: any, xhrxhr: any) {
            Dispatcher.dispatch(Actions.ACTION_API_DELETEATTACHMENT_SUCCESS, retval);
        }
        call.error = function (xhr: any, textStatus: any, errorThrown: any) {
            Dispatcher.dispatch(Actions.ACTION_API_DELETEATTACHMENT_FAIL, errorThrown);
            cms_logging.api_call_error(url, xhr, textStatus, errorThrown);
            //        console.error("ERROR " + xhr.status + " // " + url + " // " + textStatus + "  " + errorThrown)
        }
        Dispatcher.dispatch(Actions.ACTION_API_DELETEATTACHMENT_START, null);
        $.ajax(call)
    }



    /**
     *   Creates a URL attachment at the given id_location, coordinate and p1p2
     *   the success function is optional
     */

    public static post_api_CreateAttachment_url(obj: AttachmentApiObject, success_function?: any) {

        let bad_input = false;
        // check for reqired data
        function keys_are_set(obj: AttachmentApiObject, keys: string[]): boolean {
            let all_keys_are_set: boolean = true;
            keys.forEach((key: string) => {
                let val: any = (<any>obj)[key];
                if (val === undefined) {
                    all_keys_are_set = false;
                    console.error(`createattachment object is missing required entry ${key}`);
                    return false
                }
                if (val === null) {
                    all_keys_are_set = false;
                    console.error(`createattachment object is missing required entry ${key}`);
                    return false
                }
            });
            return all_keys_are_set;
        }

        if (!keys_are_set(obj, ['p1', 'p2', 'coord'])) {
            return;

        }
        if (!keys_are_set(obj, ['url'])) {
            return;
        }

        let endpoint_url = `${api_gateway}/api/drawinglocations/createattachment`
        let x = obj.coord.X
        let y = obj.coord.Y
        let p1_x = obj.p1.X
        let p1_y = obj.p1.Y
        let p2_x = obj.p2.X
        let p2_y = obj.p2.Y

        let data_to_post: any = {}
        if (obj.id_location) {
            data_to_post.idlocation = obj.id_location.toString();
        }
        if (obj.url) {
            data_to_post.url = obj.url
        }
        if (obj.base_64) {
            data_to_post.data = obj.base_64;
        }
        if (obj.file_extension) {
            data_to_post.FileExtension = obj.file_extension;
        }
        if (obj.id_room) {
            data_to_post.idroom = obj.id_room.toString();
        }
        data_to_post.xcoord = obj.coord.X;
        data_to_post.ycoord = obj.coord.Y;
        data_to_post.p1xcoord = obj.p1.X;
        data_to_post.p1ycoord = obj.p1.Y;
        data_to_post.p2xcoord = obj.p2.X;
        data_to_post.p2ycoord = obj.p2.Y;

        console.error(JSON.stringify(data_to_post));

        let call: any = build_post_api_call(endpoint_url, data_to_post)
        call.complete = function (xhr: any, textStatus: any) {
            // pass
        }
        call.success = function (retval: any, textStatus: any, xhrxhr: any) {
            Dispatcher.dispatch(Actions.ACTION_SET_ATTACHMENTS_DATA, [retval])
            if ($.isFunction(success_function)) {
                success_function(retval)
            }
        }
        call.error = function (xhr: any, textStatus: any, errorThrown: any) {
            Dispatcher.dispatch(Actions.ACTION_API_CREATE_ATTACHMENT, "error");
            cms_logging.api_call_error(endpoint_url, xhr.status, textStatus, errorThrown);
        }
        Dispatcher.dispatch(Actions.ACTION_SET_ADD_ATTACHMENT_STATE, StateValues.STATE_CREATING_ATTACHMENT_API_BUSY);
        $.ajax(call)
    }




    public static get_api_drawinglocations_getcmsviewuserconfiguration(): void {
        let endpoint_url = `${api_gateway}/api/drawinglocations/getcmsviewuserconfiguration`;

        let call = build_get_api_call(endpoint_url)
        call.complete = function (xhr: any, textStatus: any) {
            Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_CMSVIEW_USER_CONFIGURATION, false)

        }
        call.success = function (retval: any, textStatus: any, xhrxhr: any) {
            if (xhrxhr.status == 204) {
                retval = {}
            }
            if (!retval) {
                retval = {}
            }
            // Dispatcher.dispatch(Actions.ACTION_SET_ENABLED_ALLOW_3D_LINK_CREATE, true);
            Dispatcher.dispatch(Actions.ACTION_SET_ENABLED_ALLOW_3D_LINK_CREATE, retval.allow3D);
            Dispatcher.dispatch(Actions.ACTION_SET_ENABLED_PHOTO_ATTACHMENT_CREATE, true);  // AWH todo: get this value from the API
        }
        call.error = function (xhr: any, textStatus: any, errorThrown: any) {
            cms_logging.api_call_error(endpoint_url, xhr, textStatus, errorThrown);
        }
        Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_CMSVIEW_USER_CONFIGURATION, true)
        $.ajax(call)

    }

    /** 
     *  fetches data about the attachments for a given floor from the API gateway
     */
    public static api_getattachmentsbylocation(id_location: Id_location): void {
        if (!id_location) {
            cms_logging.error("api_getattachmentsbylocation(null) - do nothing.")
            return
        }
        if (!Configuration.attachments_feature_enabled) {
            cms_logging.error("api_getattachmentsbylocation() + enabled_feature_attachments = false: do nothing.")
            return
        }
        let endpoint_url = `${api_gateway}/api/DrawingLocations/GetAttachmentsByLocation/${id_location.toString()}`

        Dispatcher.dispatch(Actions.ACTION_ADD_FETCHED_ATTACHMENTS_FLOOR, id_location.toString());

        let call = build_get_api_call(endpoint_url)
        call.complete = function (xhr: any, textStatus: any) {
            Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_ATTACHMENTS, false)

        }
        call.success = function (retval: any, textStatus: any, xhrxhr: any) {
            if (xhrxhr.status == 204) {
                retval = []
            }
            if (!retval) {
                retval = []
            }

            Dispatcher.dispatch(Actions.ACTION_SET_ATTACHMENTS_DATA, retval)
        }
        call.error = function (xhr: any, textStatus: any, errorThrown: any) {
            cms_logging.error("ERROR " + "  " + textStatus + "  " + errorThrown)
        }
        Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_ATTACHMENTS, true)
        $.ajax(call)
    }

    public static api_categories() {

        //    gets the categories from the API service and dispatches them to the datastore
        //    they are stored in the following format:
        //    {
        //    10362: "Outages",
        //    35616: "Patient Safety",
        //    etc...
        //    }

        let endpoint_url = `${api_gateway}/api/categories`;
        let c: any = build_get_api_call(endpoint_url);

        c.complete = function (xhr: any, textStatus: any) {
            Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_CATEGORIES, false);
        }

        c.success = function (data: any, textStatus: any, xhrxhr: any) {

            if (xhrxhr.status == 204) {
                data = {}
            }
            if (!data) {
                cms_logging.api_call_error(endpoint_url, xhrxhr, textStatus, `The call was successful, but data was null/undefined.`)
                data = {}
            }
            Dispatcher.dispatch(Actions.ACTION_SET_CATEGORY_DATA, data);

        }

        c.error = function (xhr: any, textStatus: any, errorThrown: any) {
            cms_logging.api_call_error(endpoint_url, xhr, textStatus, errorThrown);
        }

        Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_CATEGORIES, true);
        $.ajax(c)

    }

    public static fetch_all(): void {

        this.api_categories();
        this.get_api_drawinglocations_getcmsviewuserconfiguration();
        this.api_drawinglocations_s();
        this.api_drawinglocations_f();
        this.api_drawinglocations_b();
        this.floorplan_api_maptiles_lookup();

    }

    public static api_drawinglocations_b() {
        let endpoint_url = `${api_gateway}/api/DrawingLocations/B`;
        let api_call: any = build_get_api_call(endpoint_url);
        api_call.complete = function (xhr: any, textStatus: any) {
            Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_BUILDINGS, false);
        }

        api_call.success = function (data: any, textStatus: any, xhrxhr: any) {
            if (xhrxhr.status == 204) {
                data = []
            }
            if (!exists(data)) {
                data = []
            }
            let buildings: any[] = data;
            Dispatcher.dispatch(Actions.ACTION_SET_BUILDINGS_DATA, buildings);
        }

        api_call.error = function (xhr: any, textStatus: any, errorThrown: any) {
            if (errorThrown === 'Unauthorized') {
                // console.log("Does alert dialog come up?")
                if (Keys.TOKEN_IS_BAD) {

                    Dispatcher.dispatch(Actions.ACTION_SET_TOKEN_IS_BAD, true);
                    $('#alert_the_user_modal2_title').html("Unauthorized Token");

                    $('#alert_the_user_modal2_content').html("Renew Token");


                    (<any>$('#alert_the_user_modal2')).modal({ backdrop: 'static', keyboard: false })
                }
            }
            else {
                cms_logging.api_call_error(endpoint_url, xhr, textStatus, errorThrown)
            }
        }

        Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_BUILDINGS, true);
        $.ajax(api_call);
    }


    public static api_drawinglocations_f() {

        let endpoint_url = `${api_gateway}/api/DrawingLocations/F`
        let c: any = build_get_api_call(endpoint_url);
        c.complete = function (xhr: any, textStatus: any) {
            Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_FLOORPLANS, false);
        }

        c.success = function (data: any, textStatus: any, xhrxhr: any) {
            // console.log("SUCCESS " + endpoint_url + "  " + textStatus)
            if (xhrxhr.status == 204) {
                data = []
            }
            if (!exists(data)) {
                data = []
            }
            let floorplans: any[] = data;

            Dispatcher.dispatch(Actions.ACTION_SET_FLOORPLAN_DATA, floorplans);

        }

        c.error = function (xhr: any, textStatus: any, errorThrown: any) {
            if (errorThrown === 'Unauthorized') {
                // console.log("Does alert dialog come up?")
                if (Keys.TOKEN_IS_BAD) {

                    Dispatcher.dispatch(Actions.ACTION_SET_TOKEN_IS_BAD, true);
                    $('#alert_the_user_modal2_title').html("Unauthorized Token");

                    $('#alert_the_user_modal2_content').html("Renew Token");


                    (<any>$('#alert_the_user_modal2')).modal({ backdrop: 'static', keyboard: false })
                }
            }
            else {
                console.error("ERROR " + endpoint_url + "  " + textStatus + "  " + errorThrown)
            }
        }

        Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_FLOORPLANS, true)
        $.ajax(c)
    }

    public static api_drawinglocations_r() {

        let endpoint_url = `${api_gateway}/api/DrawingLocations/R`
        let c: any = build_get_api_call(endpoint_url);
        c.complete = function (xhr: any, textStatus: any) {

            //            Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_FLOORPLANS, false);
        }

        c.success = function (data: any, textStatus: any, xhrxhr: any) {
            let floorplans: any = data;
            //            Dispatcher.dispatch(Actions.ACTION_SET_FLOORPLAN_DATA, floorplans);
        }

        c.error = function (xhr: any, textStatus: any, errorThrown: any) {
            if (errorThrown === 'Unauthorized') {
                console.log("Does alert dialog come up?")
                if (Keys.TOKEN_IS_BAD) {

                    Dispatcher.dispatch(Actions.ACTION_SET_TOKEN_IS_BAD, true);
                    $('#alert_the_user_modal2_title').html("Unauthorized Token");

                    $('#alert_the_user_modal2_content').html("Renew Token");


                    (<any>$('#alert_the_user_modal2')).modal({ backdrop: 'static', keyboard: false })
                }
            }
            else {
                cms_logging.api_call_error(endpoint_url, xhr, textStatus, errorThrown)
            }
        }

        //        Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_FLOORPLANS, true)
        $.ajax(c)
    }

    public static api_drawinglocations_s() {
        // this.api_drawinglocations_r();

        let endpoint_url = `${api_gateway}/api/DrawingLocations/S`

        let c: any = build_get_api_call(endpoint_url);

        c.complete = function (xhr: any, textStatus: any) {

            Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_SITEMAP_DATA, false);
        }

        c.success = function (data: any, textStatus: any, xhrxhr: any) {

            if (xhrxhr.status == 204) {
                data = []
            }
            if (!exists(data)) {
                data = []
            }
            let floorplans: any[] = data;
            //floorplans = CmsApi.verifyZ_Index(floorplans)
            Dispatcher.dispatch(Actions.ACTION_SET_SITEMAP_DATA, floorplans);
        }

        c.error = function (xhr: any, textStatus: any, errorThrown: any) {
            if (errorThrown === 'Unauthorized') {
                console.log("Does alert dialog come up?")
                if (Keys.TOKEN_IS_BAD) {

                    Dispatcher.dispatch(Actions.ACTION_SET_TOKEN_IS_BAD, true);
                    $('#alert_the_user_modal2_title').html("Unauthorized Token");

                    $('#alert_the_user_modal2_content').html("Renew Token");
                    (<any>$('#alert_the_user_modal2')).modal({ backdrop: 'static', keyboard: false })
                }
            }
            else {
                cms_logging.api_call_error(endpoint_url, xhr, textStatus, errorThrown);
            }
        }

        Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_SITEMAP_DATA, true)
        $.ajax(c)
    }

    
    public static fetch_build_id() {
        let endpoint_url = `buildId.txt`;
        let c: any = build_get_txt_call(endpoint_url);
        c.complete = function (xhr: any, textStatus: any) {
        }

        c.success = function (data: any, textStatus: any, xhrxhr: any) {

            if (xhrxhr.status == 204) {
                data = "EMPTY"
            }
            if (!data) {
                data = "EMPTY"
            }
            let build_id:string=<string>data;
            build_id=build_id.trim();
            Dispatcher.dispatch(Actions.ACTION_SET_BUILD_ID, build_id);
        }

        c.error = function (xhr: any, textStatus: any, errorThrown: any) {
            console.error("Fetching Build id failed")  // AWH -> KTH clean up
        }

      //  Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_DRAWINGS_INFO, true)
        $.ajax(c)
    }

    
    public static floorplan_api_maptiles_lookup() {
		let endpoint_url = `${QueryString.api_gateway}/api/Drawings/site/${Configuration.database_name}`;
        let c: any = build_get_api_call(endpoint_url);
        c.complete = function (xhr: any, textStatus: any) {
            Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_DRAWINGS_INFO, false);
        }

        c.success = function (data: any, textStatus: any, xhrxhr: any) {

            if (xhrxhr.status == 204) {
                data = {}
            }
            if (!data) {
                data = {}
            }
            let drawing_info: any = data;
            console.log(drawing_info);

            Dispatcher.dispatch(Actions.ACTION_SET_DRAWINGS_INFO_DATA, drawing_info);
        }

        c.error = function (xhr: any, textStatus: any, errorThrown: any) {
            if (errorThrown === 'Not Found') {
                console.log("Drawings info not set for this building")  // AWH -> KTH clean up
            }
            else {
                cms_logging.api_call_error(endpoint_url, xhr, textStatus, errorThrown);
            }
        }

        Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_DRAWINGS_INFO, true)
        $.ajax(c)
    }

    public static api_drawinglocations_updateattachment(attachment_url: string,
        id_attachment: number,
        id_floor: number,
        coords: Point,
        geo_reference: Rectangle,
        success_function: any): void {

        let endpoint_url = `${api_gateway}/api/drawinglocations/updateattachment`

        let x = coords.X;
        let y = coords.Y;
        let p1_x = geo_reference.P1.X; // geo_reference[0][0]
        let p1_y = geo_reference.P1.Y; // geo_reference[0][1]
        let p2_x = geo_reference.P2.X; // geo_reference[1][0]
        let p2_y = geo_reference.P2.Y; // geo_reference[1][1]
        let data_to_post: any = {
            //data : attachment_b64,
            //FileExtension : file_extension,
            url: attachment_url,
            id: id_attachment,
            idlocation: id_floor,
            idroom: "",
            xcoord: x,
            ycoord: y,
            p1xcoord: p1_x,
            p1ycoord: p1_y,
            p2xcoord: p2_x,
            p2ycoord: p2_y
        }

        let call = build_post_api_call(endpoint_url, data_to_post)
        call.complete = function (xhr: any, textStatus: any) {
            // pass
        }
        call.success = function (retval: any, textStatus: any, xhrxhr: any) {
            //  dispatch(Actions.ACTION_API_UPDATEATTACHMENT_SUCCESS, retval);
            Dispatcher.dispatch(Actions.ACTION_API_UPDATEATTACHMENT_SUCCESS, retval)
            if ($.isFunction(success_function)) {
                success_function(retval)
            }
        }
        call.error = function (xhr: any, textStatus: any, errorThrown: any) {
            Dispatcher.dispatch(Actions.ACTION_API_UPDATEATTACHMENT_FAIL, "error")
            console.error("ERROR " + xhr.status + " // " + endpoint_url + " // " + textStatus + "  " + errorThrown)
        }

        Dispatcher.dispatch(Actions.ACTION_API_UPDATEATTACHMENT_START, null)
        $.ajax(call)
    }


    public static api_roundingdrawinglocations_getfindingsbyfloor(id_floor: Id_floor): void {
        if (id_floor === null) {
            console.error("api/RoundFindings/ByFloor(null) - do nothing.")
            return
        }
        if (!Configuration.findings_feature_enabled) {
            cms_logging.log("api/RoundFindings/ByFloor() + enabled_feature_findings = false: do nothing.")
            return
        }
        for (var i = 0; i < CmsApi.findings_floors_downloaded.length; i++) {
            if (CmsApi.findings_floors_downloaded[i].equals(id_floor)) {
                cms_logging.log(`attempting second download of ${id_floor.toString()}`);
                return;
            }
        }

        var endpoint_url = `${api_gateway}/api/RoundFindings/ByFloor/${id_floor.toString()}`;

        let c: any = build_get_api_call(endpoint_url);

        c.complete = function (xhr: any, textStatus: any) {
            Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_FINDINGS, false);
        }

        c.success = function (data: any, textStatus: any, xhrxhr: any) {
            console.log("SUCCESS " + endpoint_url + "  " + textStatus)

            if (data === undefined) {
                console.error(`${endpoint_url} returned nothing.`)
                data = []
            }

            if (data == null) {
                console.error(`${endpoint_url} returned null.`)
                data = []
            }
            let findings: any = data
            Dispatcher.dispatch(Actions.ACTION_SET_FINDINGS_DATA, findings);
        }
        c.error = function (xhr: any, textStatus: any, errorThrown: any) {
            console.log("ERROR " + endpoint_url + "  " + textStatus + "  " + errorThrown)
        }

        CmsApi.findings_floors_downloaded.push(id_floor);
        Dispatcher.dispatch(Actions.ACTION_ADD_FETCHED_FINDINGS_FLOOR, id_floor);
        Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_FINDINGS, true);
        $.ajax(c)
    }


    public static api_DrawingLocations_GetAssetsByFloor(id_floor: Id_floor): void {
        if (id_floor === null) {
            console.error("api_DrawingLocations_GetAssetsByFloor(null) - do nothing.")
            return
        }
        if (!Configuration.assets_feature_enabled) {
            console.error("api_DrawingLocations_GetAssetsByFloor() + enabled_feature_assets = false: do nothing.")
            return
        }


        var endpoint_url = `${api_gateway}/api/DrawingLocations/GetAssetsByFloor/${id_floor.toString()}`

        let c: any = build_get_api_call(endpoint_url);

        c.complete = function (xhr: any, textStatus: any) {
            Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_ASSETS, false);
        }

        c.success = function (data: any, textStatus: any, xhrxhr: any) {
            console.log("SUCCESS " + endpoint_url + "  " + textStatus)

            if (data === undefined) {
                console.error(endpoint_url + " returned nothing.")
                data = []
            }

            if (data == null) {
                console.error(endpoint_url + " returned null.")
                data = []
            }
            let assets: any = data
            Dispatcher.dispatch(Actions.ACTION_SET_ASSET_DATA, assets);
        }
        c.error = function (xhr: any, textStatus: any, errorThrown: any) {
            console.log("ERROR " + endpoint_url + "  " + textStatus + "  " + errorThrown)
        }

        Dispatcher.dispatch(Actions.ACTION_ADD_FETCHED_ASSETS_FLOOR, id_floor);
        Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_ASSETS, true);
        $.ajax(c)
    }



    public static api_get_workorders(workorder_query: any): void {
        if (!workorder_query) {
             console.error("attempted to fetch workorders with no workorder_query value")
            return;
        }
        if (!Configuration.workorders_feature_enabled) {
            cms_logging.error("api_get_workorders() + enabled_feature_workorders = false: do nothing.")
            return
        }

        let url: string = `${api_gateway}/api/workorders/query`;

        let wo_headers: any = {
            Authorization: "Bearer " + api_token,
            Accept: "application/json, text/plain, */*",
            CmsSegmentId: api_id_segment,
            "Cache-Control": "no-cache",
        }

        let c: any = {
            type: "POST",
            headers: wo_headers,
            url: url,
            contentType: 'application/json; charset=utf-8',
            dataType: "json",
            error: function (xhr: any, textStatus: any, errorThrown: any) {
                cms_logging.api_call_error(url, xhr, textStatus, errorThrown);
                //            console.error("ERROR " + wo_url + "  " + textStatus + "  " + errorThrown)
            },
            data: JSON.stringify(workorder_query)
        }

        c.complete = function (xhr: any, textstatus: any) {
            Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_WORKORDERS, false);
        };
        c.success = function (http_content: any, textStatus: any, xhrxhr: any) {
            Dispatcher.dispatch(Actions.SET_WORKORDERS_DATA, http_content)
        };
        Dispatcher.dispatch(Actions.ACTION_SET_FETCHING_WORKORDERS, true);
        $.ajax(c);
    }
}


// WEBPACK FOOTER //
// ./src/ts/cms_api.ts